import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { MoveTokenResponse } from '@/types/api/mypage/moveTokenResponse';

/** 移転コード情報取得APIのURL */
const url = ApiUrl.Read.MOVE_TOKEN_INFO;

/**
 * 移転コード情報取得APIの呼び出しフック。
 * 発行済みの引っ越しコードと有効期限、表示可否を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetMoveTokenInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<MoveTokenResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetMoveTokenInfo;
